import ChartManagement from './ChartManagement';

export default ChartManagement;
